import { Component } from 'react';

export default class PlaceholderCard extends Component {
  render() {
    return (
      <div className="consortia__carousel-placeholder__item">
        <div className="ph-item">
          <div className="ph-col-12">
            <div className="ph-picture" />
            <div className="ph-row">
              <div className="ph-col-2 empty" />
              <div className="ph-col-8 big" />
              <div className="ph-col-2 empty" />
            </div>
            <div className="ph-row">
              <div className="ph-col-8" />
              <div className="ph-col-8" />
              <div className="ph-col-8" />
            </div>
            <div className="ph-row">
              <div className="ph-col-2 empty" />
              <div className="ph-col-8 big" />
              <div className="ph-col-2 empty" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PlaceholderCard.defaultProps = {};

PlaceholderCard.propTypes = {};
